import { request } from 'api';
import { FileContentDto } from 'types';

export const FileDescriptorService = {
  downloadSingleFile(link: string) {
    return request<FileContentDto>('get', `/api/File/FileDescriptor/Download/Single/${link}`);
  },
};
